export const LOGO_GARDEN_CONTENT = `
logoGardenContent {
  ... on logoGardenContent_Entry {
    images {
      id
      url
      title
      width
      height
    }
  }
}
`

export const LOGO_GARDEN = `
...on logoGarden_Entry {
  id
  typeHandle
  isStatic
  ${ LOGO_GARDEN_CONTENT }
}
`